import { render, staticRenderFns } from "./BookingWayPoint.vue?vue&type=template&id=2bcb6b54"
import script from "./BookingWayPoint.vue?vue&type=script&lang=js"
export * from "./BookingWayPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports